const defaultTheme = {
  colors: {
    background: '#FFF',
    text: '#000',
    panel: '#DDD',
    primary: 'white',
    primaryBorder: '1px solid #d5dbe2',
    primaryText: '#3a3a3a',
    secondary: '#75E6C7',
    secondaryText: '#FFF',
    disabled: '#888',
    disabledText: '#FFF',
  },
};

export default defaultTheme;
